import { createTheme } from "@mantine/core";

export const theme = createTheme({
  fontFamily: "Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
  fontFamilyMonospace: "Roboto Mono, Monaco, Courier, monospace",
  primaryColor: "eu_flag",
  primaryShade: { light: 9, dark: 6 },
  colors: {
    blue: [
      "#c8e0f5",
      "#a8c8e8",
      "#7ba3d4",
      "#4d7cc0",
      "#2d5fad",
      "#1d4a9a",
      "#153d8a",
      "#0f3273",
      "#0a285f",
      "#061f4d",
    ],
    eu_flag: [
      "#c8d8f0",
      "#a8bce0",
      "#7a95d0",
      "#4d6bc0",
      "#2d4aad",
      "#1d3a9a",
      "#152f8a",
      "#0f2573",
      "#0a1d5f",
      "#02164d",
    ],
    light_azure: [
      "#c0d8f0",
      "#a0b8e0",
      "#6d95d0",
      "#3d6bc0",
      "#1d4aad",
      "#0d3a9a",
      "#0a2f8a",
      "#0a2573",
      "#001d5f",
      "#00164d",
    ],
    eu_gold: [
      "#fffbe1",
      "#fff6cb",
      "#ffeb9a",
      "#ffe064",
      "#ffd738",
      "#ffd11c",
      "#ffcc00",
      "#e3b600",
      "#caa100",
      "#ae8b00",
    ],
    modern_teal: [
      "#ebfffd",
      "#d7fdfa",
      "#a9fdf5",
      "#7bfdf0",
      "#5efdeb",
      "#51fde9",
      "#49fde8",
      "#3ce1cd",
      "#2cc8b6",
      "#009688",
    ],
    charcoal_gray: [
      "#f5f5f5",
      "#e7e7e7",
      "#cdcdcd",
      "#b2b2b2",
      "#9a9a9a",
      "#8b8b8b",
      "#848484",
      "#717171",
      "#656565",
      "#202020",
    ],
    dark_gray: [
      "#eef5ff",
      "#e2e7ee",
      "#c6ccd5",
      "#a8b0bb",
      "#8f98a5",
      "#7e8999",
      "#6e7b8d",
      "#636f81",
      "#566375",
      "#465669",
    ],
    gray: [
      "#ebf7fe",
      "#e1e9ed",
      "#c3cdd3",
      "#a7b4bc",
      "#8e9ea8",
      "#7d8f9b",
      "#738996",
      "#607683",
      "#526976",
      "#405b6a",
    ],
    soft_gray: [
      "#eef2f5",
      "#e6e7e8",
      "#c8ced3",
      "#a6b3bd",
      "#8b9dab",
      "#798ea0",
      "#6e879c",
      "#5d7588",
      "#50687a",
      "#405a6d",
    ],
    white: [
      "#ffffff",
      "#e7e7e7",
      "#cdcdcd",
      "#b2b2b2",
      "#9a9a9a",
      "#8b8b8b",
      "#848484",
      "#717171",
      "#656565",
      "#575757",
    ],
    border: [
      "#eef6fc",
      "#dee4e9",
      "#c6ced5",
      "#a6b3bd",
      "#8b9baa",
      "#798d9e",
      "#6f8699",
      "#5d7386",
      "#516779",
      "#40596c",
    ],
    danger: [
      "#ffebeb",
      "#fbd7d7",
      "#eeadad",
      "#e38080",
      "#da5a5a",
      "#d54242",
      "#d43a3a",
      "#bb2728",
      "#a82022",
      "#93151b",
    ],
    background: [
      "#d8e0f0",
      "#b8c5d8",
      "#8fa0c0",
      "#6b7ba8",
      "#4d5f90",
      "#3d4f7a",
      "#35456a",
      "#2d3a5a",
      "#25304a",
      "#1d253a",
    ],
  },
});
